<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-sm-and-up white--text"></v-toolbar-side-icon>
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ deliveryOrderNo }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-4">
            <v-layout align-center class="mb-5">
              <v-flex text-xs-center >
                <div class="headline font-weight-medium text-center pl-3 pr-3 pt-3">{{ deliveryOrderNo }}</div>
                <div class="body-2 font-weight-bold text-center pl-3 pr-3">Order No: {{ salesOrderNo }}</div>
                <div class="body-2 font-weight-bold text-center pl-3 pr-3">{{ invoiceNo }}</div>
                <div class="body-2 pl-3 pr-3 grey--text">{{ createdDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}</div>
                <v-btn
                  outline
                  small
                  color="primary"
                  class="mr-1"
                  v-if="trackingNo"
                  :href="fullTrackingUrl"
                  target="_blank"
                >Track</v-btn>
                <v-btn
                  outline
                  small
                  color="primary"
                  class="ml-1"
                  @click="emailDialog = true"
                >View Email</v-btn>
                <div class="body-2 pl-3 pr-3 grey--text" v-if="trackingNo.length > 0">
                  Tracking No: {{ trackingNo }}
                  <v-btn
                    outline
                    small
                    color="primary"
                    class="mr-1"
                    @click="showEditTrackingDialog"
                  >Edit</v-btn>
                </div>
              </v-flex>
            </v-layout>

            <div v-if="totalShippingWeight > 0">
              <v-divider inset></v-divider>
              <v-list>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">perm_identity</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingTitle }} {{ shippingFirstName }} {{ shippingLastName }} - {{ shippingEmail }}
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider v-if="shippingCompany" inset></v-divider>
              <v-list v-if="shippingCompany">
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">store</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingCompany }}
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider inset></v-divider>
              <v-list three-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">home</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingAddress }}
                    <v-list-tile-sub-title>{{ shippingCityName}}, {{ shippingPostCode }}, {{ shippingProvinceName }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider inset></v-divider>
              <v-list>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">call</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingPhone }}
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider inset></v-divider>
            </div>
            <v-list>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">local_shipping</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{ (customCourierName.length > 0 ? customCourierName : courierName + ' - ' + serviceName) }}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-data-table
              :items="items"
              hide-actions
              class="elevation-1 mt-5"
            >
              <template slot="headers">
                <tr class="grey lighten-4">
                  <th class="text-xs-left subheading font-weight-bold">
                    Item Name
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Qty
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <table>
                    <tr>
                      <td valign="top" class="item-name">
                        <img v-if="props.item.images.length > 0" :src="props.item.images[0].smallUrl" class="item-thumb">
                        <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                      </td>
                      <td class="item-name">
                        <strong>{{ props.item.name }}</strong>
                        <div v-for="(optionItem, optionItemIndex) in props.item.options" :key="optionItemIndex">
                          {{ optionItem.optionName }}: {{ optionItem.valueCode }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
                <td class="text-xs-center">{{ props.item.qty }} {{ props.item.unit }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogEditTracking" @keydown.esc="dialogEditTracking = false" max-width="700px">
        <v-card>
          <v-card-title>
            <h3 class="headline font-weight-bold">Edit Tracking</h3>
          </v-card-title>
          <v-card-text>
            <v-form ref="frmEditTracking" v-model="frmEditTrackingValid" @submit.prevent="">
              <v-container fluid grid-list-xs>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="cboCourier"
                      :rules="[v => !!v || 'Please select a Courier']"
                      :items="couriers"
                      item-text="courierName"
                      item-value="courierId"
                      label="Courier"
                      @change="selectCourier(cboCourier)"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 v-if="cboCourier !== 'CUSTOM'">
                    <v-select
                      v-model="cboService"
                      :rules="[v => !!v || 'Please select a service']"
                      :items="courierServices"
                      item-text="description"
                      item-value="service"
                      label="Service"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 v-if="cboCourier === 'CUSTOM'">
                    <v-text-field
                      v-model="txtCustomCourierName"
                      :rules="[v => !!v || 'Custom courier name is required']"
                      label="Custom Courier Name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 v-if="cboCourier === 'CUSTOM'">
                    <v-text-field
                      v-model="txtCustomTrackingUrl"
                      :rules="[v => !!v || 'Custom tracking URL is required']"
                      label="Custom Tracking URL (with http:// or https://)"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <trumbowyg
                      v-if="cboCourier === 'COU-INSTANT' && cboService === 'EMAIL'"
                      v-model='txtMessage'
                    ></trumbowyg>
                    <v-text-field
                      v-else
                      v-model="txtTrackingNo"
                      :rules="[v => !!v || 'Tracking no is required']"
                      label="Tracking No"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <input
                      type="file"
                      multiple
                      style="display: none"
                      ref="filePicker"
                      accept="*"
                      @change="onFilePicked"
                      @click="$refs.filePicker.value = null"
                    >
                    <v-container fluid grid-list-xs>
                      <v-layout row wrap>
                        <v-flex xs3 sm1 class="mt-1">
                          <span class="font-weight-bold">Files</span>
                        </v-flex>
                        <v-flex xs9 sm11>
                          <v-chip
                            v-for="(file, fileIndex) in fileUploads"
                            :key="fileIndex"
                            @input="removeFileUpload(fileIndex)"
                            close
                          >
                            <v-avatar v-if="file.uploadStatus === 'success'">
                              <v-icon color="green">check_circle</v-icon>
                            </v-avatar>
                            <v-avatar v-else-if="file.uploadStatus === 'error'">
                              <v-icon color="red">error</v-icon>
                            </v-avatar>
                            <v-avatar v-else-if="file.uploadStatus === 'uploading'">
                              <v-icon color="orange">hourglass_full</v-icon>
                            </v-avatar>
                            {{ (file.fileName ? file.fileName : file.name) }}
                          </v-chip>
                          <v-btn
                            outline
                            icon
                            small
                            v-if="fileUploads.length < 3"
                            class="ml-2 mr-0 mt-0 mb-0"
                            @click="pickFile"
                          >
                            <v-icon small>add</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      block
                      large
                      color="primary"
                      :disabled="!frmEditTrackingValid"
                      @click="updateTracking"
                    >
                      Save
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="emailDialog" max-width="800px">
        <v-card>
          <v-card-text>
            <iframe id="shipmentEmailIframe" style="width:100%; height:400px;" :src="'/shipment/email/' + deliveryOrderNo"></iframe>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>

    </v-content>
  </div>
</template>

<style scoped>
  .media {
    height: 100%;
    margin: 0;
  }

  table.v-table tbody td:first-child {
    padding: 15px 15px;
  }

  .item-name {
    padding: 5px !important;
  }

  .item-thumb {
    width: 60px;
    height: auto;
  }
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  props: [
    'deliveryOrderNo'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      drawer: false,
      loading: false,
      headers: [
        {
          text: 'Item Name',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        { text: 'Qty', value: 'qty', align: 'right', sortable: false }
      ],
      emailBody: '',
      emailDialog: false,
      salesOrderNo: '',
      invoiceNo: '',
      createdDateTime: '',
      shippingTitle: '',
      shippingFirstName: '',
      shippingLastName: '',
      shippingCompany: '',
      shippingAddress: '',
      shippingPostCode: '',
      shippingCityId: '',
      shippingCityName: '',
      shippingProvinceId: '',
      shippingProvinceName: '',
      shippingCountryId: '',
      shippingCountryName: '',
      shippingPhone: '',
      shippingEmail: '',
      courierId: '',
      courierName: '',
      serviceCode: '',
      serviceName: '',
      customCourierName: '',
      trackingNo: '',
      trackingUrl: '',
      customTrackingUrl: '',
      fullTrackingUrl: '',
      items: [],
      files: [],
      dialogEditTracking: false,
      frmEditTrackingValid: false,
      cboCourier: null,
      cboService: null,
      txtCustomCourierName: '',
      txtCustomTrackingUrl: '',
      txtTrackingNo: '',
      txtMessage: '',
      fileUploads: [],
      couriers: [],
      courierServices: [],
      totalShippingWeight: 0
    }
  },
  mounted () {
    this.openDrawerForDesktop()
    this.getDeliveryOrderDetails()
    this.disableBottomDetector()
  },
  watch: {
    cboCourier (newValue, oldValue) {
      for (var c = 0; c < this.couriers.length; ++c) {
        if (this.couriers[c].courierId === newValue) {
          this.courierServices = this.couriers[c].rates
          break
        }
      }
    }
  },
  methods: {
    selectCourier: function (courierId) {
      if (courierId === 'CUSTOM') {
        this.txtCustomCourierName = ''
        this.txtCustomTrackingUrl = ''
      }

      for (var c = 0; c < this.couriers.length; ++c) {
        if (this.couriers[c].courierId === courierId) {
          this.courierServices = this.couriers[c].rates
        }
      }
    },
    pickFile: function () {
      this.$refs.filePicker.click()
    },
    onFilePicked: function (e) {
      const files = e.target.files
      console.log(files)

      if (files.length + this.fileUploads.length > 3) {
        window.alert('You can only upload maximum of 3 files')
        return false
      }

      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          const fr = new FileReader()
          fr.readAsDataURL(files[i])
          var _this = this
          fr.addEventListener('load', () => {
            _this.fileUploads.push({
              name: files[i].name,
              url: fr.result,
              file: files[i]
            })
          })
        }
      }
    },
    removeFileUpload: function (fileIndex) {
      this.fileUploads.splice(fileIndex, 1)
    },
    showEditTrackingDialog: function () {
      this.cboCourier = this.courierId
      this.cboService = this.serviceCode
      this.txtCustomCourierName = this.customCourierName
      this.txtTrackingNo = this.trackingNo
      this.txtCustomTrackingUrl = this.customTrackingUrl
      this.fileUploads = this.deepCopy(this.files)
      for (var i in this.fileUploads) {
        this.fileUploads[i].uploadStatus = 'success'
      }

      this.getCourierRates()
      this.dialogEditTracking = true
    },
    getDeliveryOrderDetails: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/delivery/' + _this.deliveryOrderNo)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.salesOrderNo = resp.data.data.salesOrderNo
            _this.invoiceNo = resp.data.data.invoiceNo
            _this.createdDateTime = resp.data.data.createdDateTime
            _this.createdDateTime = resp.data.data.createdDateTime
            _this.shippingTitle = resp.data.data.shippingTitle
            _this.shippingFirstName = resp.data.data.shippingFirstName
            _this.shippingLastName = resp.data.data.shippingLastName
            _this.shippingCompany = resp.data.data.shippingCompany
            _this.shippingPhone = resp.data.data.shippingPhone
            _this.shippingAddress = resp.data.data.shippingAddress
            _this.shippingPostCode = resp.data.data.shippingPostCode
            _this.shippingCityId = resp.data.data.shippingCityId
            _this.shippingCityName = resp.data.data.shippingCityName
            _this.shippingProvinceId = resp.data.data.shippingProvinceId
            _this.shippingProvinceName = resp.data.data.shippingProvinceName
            _this.shippingCountryID = resp.data.data.shippingCountryId
            _this.shippingCountryName = resp.data.data.shippingCountryName
            _this.shippingEmail = resp.data.data.shippingEmail
            _this.status = resp.data.data.status
            _this.customCourierName = resp.data.data.customCourierName
            _this.courierId = resp.data.data.courierId
            _this.courierName = resp.data.data.courierName
            _this.serviceCode = resp.data.data.serviceCode
            _this.serviceName = resp.data.data.serviceName
            _this.trackingNo = resp.data.data.trackingNo
            _this.trackingUrl = resp.data.data.trackingUrl
            _this.customTrackingUrl = resp.data.data.customTrackingUrl
            _this.fullTrackingUrl = resp.data.data.fullTrackingUrl
            _this.items = resp.data.data.items
            _this.files = resp.data.data.files
            _this.emailBody = resp.data.data.emailBody

            // calculate weight
            var weight = 0
            for (var i in resp.data.data.items) {
              weight += resp.data.data.items[i].unitWeight * resp.data.data.items[i].qty
            }
            _this.totalShippingWeight = weight
          } else {
            console.log('unable to load delivery order details: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(_this)
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    getCourierRates: function () {
      var _this = this
      var userProfile = _this.getUserProfile()
      if (_this.totalShippingWeight <= 0) {
        _this.couriers = [{
          courierId: 'COU-INSTANT',
          courierName: 'Instant Shipment',
          countryId: userProfile.storeCountryId,
          cityId: userProfile.storeCityId,
          status: 'active',
          countryName: userProfile.storeCountryName,
          rates: [{
            service: 'EMAIL',
            description: 'Email',
            weightLimit: 0,
            packageCount: 1,
            cost: {
              value: 0,
              etd: '1',
              note: ''
            }
          }]
        }]
      } else {
        var queryString
        if (_this.shippingCityId && _this.shippingCityId.length > 0) {
          queryString = 'destination_city_id=' + _this.shippingCityId
        } else if (_this.shippingProvinceId && _this.shippingProvinceId.length > 0) {
          queryString = 'destination_province_id=' + _this.shippingProvinceId
        } else {
          queryString = 'destination_country_id=' + _this.shippingCountryId
        }

        _this.couriers = []
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/shipping/rates?weight=1&origin_city_id=' + userProfile.storeCityId + '&' + queryString)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.loading = false
              _this.dialogShipment = true
              _this.couriers = resp.data.data
              _this.couriers.push({
                courierId: 'CUSTOM',
                courierName: 'Custom Courier',
                status: 'active',
                rates: []
              })
              _this.selectCourier(_this.cboCourier)
            } else {
              console.log('unable to get couriers: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log('get couriers : ' + error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      }
    },
    updateTracking () {
      var _this = this
      if (_this.$refs.frmEditTracking.validate()) {
        _this.loading = true

        // inject files
        var i, j
        var isUploadFile = false
        var formData = new FormData()
        for (i in _this.fileUploads) {
          if (typeof _this.fileUploads[i].uploadStatus === 'undefined' || _this.fileUploads[i].uploadStatus !== 'success') {
            formData.append('file' + (parseInt(i) + 1), _this.fileUploads[i].file, _this.fileUploads[i].name)
            _this.fileUploads[i].uploadStatus = 'uploading'
            isUploadFile = true
          }
        }

        if (isUploadFile) {
          // upload files
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/delivery/file', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(resp => {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                var errorCount = 0
                for (i = 1; i <= 3; i++) {
                  if (typeof resp.data.data['file' + i] !== 'undefined' && typeof resp.data.data['file' + i].deliveryOrderFileId !== 'undefined') {
                    for (j in _this.fileUploads) {
                      if (resp.data.data['file' + i].fileName === _this.fileUploads[j].name) {
                        if (typeof resp.data.data['file' + i].deliveryOrderFileId !== 'undefined') {
                          _this.fileUploads[j].deliveryOrderFileId = resp.data.data['file' + i].deliveryOrderFileId
                          _this.fileUploads[j].uploadStatus = 'success'
                        } else {
                          _this.fileUploads[j].uploadStatus = 'error'
                          errorCount++
                        }
                        break
                      }
                    }
                  }
                }

                // only continue if all upload success
                if (errorCount === 0) {
                  _this.submitUpdateTracking()
                } else {
                  window.alert(errorCount + ' of the file upload failed, please retry')
                }
              } else {
                window.alert(resp.data.message)
              }
              _this.loading = false
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          _this.submitUpdateTracking()
        }
      }
    },
    submitUpdateTracking () {
      var _this = this
      if (_this.$refs.frmEditTracking.validate()) {
        // Native form submission is not yet supported

        var submitData = {
          trackingNo: _this.txtTrackingNo
        }

        // inject courier id or custom courier
        if (_this.cboCourier === 'CUSTOM') {
          submitData.customCourierName = _this.txtCustomCourierName
          submitData.customTrackingUrl = _this.txtCustomTrackingUrl
        } else {
          submitData.courierId = _this.cboCourier
          submitData.serviceCode = _this.cboService
        }

        // inject files
        if (_this.fileUploads.length > 0) {
          var fileIds = []
          for (var i in _this.fileUploads) {
            fileIds.push(_this.fileUploads[i].deliveryOrderFileId)
          }
          submitData.fileIds = fileIds
        }

        _this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/delivery/' + _this.deliveryOrderNo, submitData)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.dialogEditTracking = false
              _this.getDeliveryOrderDetails()
              document.getElementById('shipmentEmailIframe').contentWindow.location.reload()
              window.alert('Tracking updated and customer has been notified')
            } else {
              window.alert('Unable to update tracking: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      }
    }
  }
}
</script>
